module.exports = __webpack_public_path__ + "283b623cd23d86e67bf0db4280b6634a.svg";